import { render } from "./MatchStats.vue?vue&type=template&id=dca272d4"
import script from "./MatchStats.vue?vue&type=script&lang=js"
export * from "./MatchStats.vue?vue&type=script&lang=js"

import "./MatchStats.vue?vue&type=style&index=0&id=dca272d4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__